module.exports = __webpack_public_path__ + "static/img/getFreeBox.967a8b7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/getFreeBox.webp
// module id = utBY
// module chunks = 0